'use client';
import { createContext } from 'react';
import { theme } from '@wanteddev/wds-theme';

// src/context/index.ts
var ThemeContext = createContext(theme.light);
if (process.env.NODE_ENV !== "production") {
  ThemeContext.displayName = "ThemeContext";
}
var context_default = ThemeContext;

export { context_default as default };
